const paymentApplication = {
  // == Page header / verify flow ==
  'payment_application.page.title': 'Solicitud de Pago',
  'payment_application.page.logo.alt': 'Logotipo de TouchBistro',
  'payment_application.continue.body':
    'Haga clic en el botón a continuación para acceder a su solicitud de pago.',
  'payment_application.continue.header': 'Continúe a su Solicitud de Pago',
  'payment_application.continue.submit': 'Continuar',
  'payment_application.continue.error.retry':
    'No pudimos conectarnos al servidor. Por favor, inténtelo de nuevo.',
  'payment_application.verify.header': 'Solicitar un Nuevo Enlace de Acceso',
  'payment_application.verify.body':
    'Su enlace de solicitud anterior puede haber expirado, ya haber sido utilizado, o su sesión puede haberse interrumpido.',
  'payment_application.verify.body_secondary':
    'Ingrese la dirección de correo electrónico asociada con su solicitud y le enviaremos un nuevo enlace de acceso seguro.',
  'payment_application.verify.body_warning':
    'Solicitar un nuevo enlace invalidará cualquier enlace emitido anteriormente.',
  'payment_application.verify.illustration.alt':
    'Ilustración de un mesero sosteniendo una terminal de pago y un cliente sosteniendo una tarjeta de crédito en un restaurante',
  'payment_application.verify.field.email.label': 'Correo Electrónico',
  'payment_application.verify.submit': 'Enviar',
  'payment_application.verify.success.header': 'Revise su correo electrónico',
  'payment_application.verify.success.body':
    'Si hay una cuenta asociada con la dirección de correo electrónico que ingresó, recibirá un correo electrónico con un nuevo enlace seguro para acceder a su solicitud de pago.',
  'payment_application.verify.success.body_secondary':
    'Por motivos de seguridad, cualquier enlace emitido anteriormente ahora no es válido.',
  'payment_application.verify.success.close': 'Cerrar',
  'payment_application.footer.support_text':
    'Si tiene alguna pregunta, por favor contacte a nuestro equipo de servicios profesionales:',
  'payment_application.footer.phone.label': 'T',
  'payment_application.footer.email.label': 'E',
  'payment_application.stepper.aria_label': 'Progreso de la solicitud de pago',
  'payment_application.stepper.business_details': 'Detalles del Negocio',
  'payment_application.stepper.business_owners': 'Propietarios del Negocio',
  'payment_application.stepper.banking_details': 'Datos Bancarios',
  'payment_application.stepper.portal_account_setup': 'Configuración de la Cuenta del Portal',
  'payment_application.stepper.review_and_submit': 'Revisar y Enviar',

  // == Intro Page ==
  'payment_application.intro.header.title': 'Antes de empezar',
  'payment_application.intro.header.body':
    'Para solicitar TouchBistro Payments, con tecnología de <strong>Payrix</strong>, debe proporcionar información sobre su negocio, estructura de propiedad y cuenta bancaria.',
  'payment_application.intro.header.note':
    'Esta solicitud debe <strong>completarse de una sola vez</strong> porque <strong>no se puede guardar a medias</strong>, y tomará aproximadamente <strong>15 minutos</strong>. Solo está disponible en <strong>computadoras de escritorio</strong>.',
  'payment_application.intro.checklist.header': 'Tenga a mano lo siguiente antes de comenzar:',
  'payment_application.intro.checklist.ein': 'Su carta de asignación de <strong>EIN/IRS</strong>',
  'payment_application.intro.checklist.formation_document':
    'Su <strong>documento de constitución</strong>',
  'payment_application.intro.checklist.bank_proof':
    'Un <strong>cheque anulado</strong>, un <strong>extracto bancario</strong> o una <strong>carta bancaria</strong>',
  'payment_application.intro.checklist.owners':
    'Un <strong>número de seguro social</strong> y los datos de contacto de <strong>todos los propietarios</strong> con una participación del <strong>25%</strong> o más',
  'payment_application.intro.cta.get_started': 'Empezar',
  'payment_application.intro.illustration.alt':
    'Ilustración de una persona subiendo escaleras con una carpeta junto a formas abstractas',

  // == Business Details Page ==
  'payment_application.business_details.header.title': 'Detalles del Negocio',
  'payment_application.business_details.header.body':
    'Ayúdenos a entender su negocio para que podamos procesar su cuenta de pago correctamente. Esta sección se centra en lo básico que necesitamos para comenzar.',

  // Business Name section
  'payment_application.business_details.business_name.section': 'Nombre del Negocio',

  // Legal Business Name
  'payment_application.business_details.legal_business_name.label': 'Razón Social',
  'payment_application.business_details.legal_business_name.placeholder':
    'Ingrese la razón social de su negocio',
  'payment_application.business_details.legal_business_name.helper':
    'El nombre debe coincidir exactamente con el indicado en la carta de asignación de EIN/IRS. Las empresas unipersonales utilizan el nombre del propietario como razón social.',

  // Doing Business As
  'payment_application.business_details.doing_business_as.label':
    'Nombre Comercial ("Doing Business As")',
  'payment_application.business_details.doing_business_as.placeholder':
    'Ingrese el nombre comercial',
  'payment_application.business_details.doing_business_as.helper':
    'Esto es lo que aparecerá en el extracto de la tarjeta del cliente.',

  // Business Operations section
  'payment_application.business_details.business_operations.section': 'Operaciones del Negocio',

  // Industry
  'payment_application.business_details.industry.label': 'Industria',
  'payment_application.business_details.industry.placeholder': 'Seleccione una opción',
  'payment_application.business_details.industry.helper':
    'Seleccione la opción que mejor refleje los servicios que ofrece.',

  // Payment Method
  'payment_application.business_details.payment_method.label':
    '¿Cómo acepta pagos su negocio principalmente?',
  'payment_application.business_details.payment_method.placeholder': 'Seleccione una opción',

  // Batch Time
  'payment_application.business_details.batch_time.label': 'Hora de Cierre de Lote',
  'payment_application.business_details.batch_time.placeholder': 'Seleccione una opción',
  'payment_application.business_details.batch_time.helper':
    'Establezca la fecha y hora en que las transacciones por lote de su red se cerrarán automáticamente para liquidación.',

  // Expected Annual Volume
  'payment_application.business_details.expected_annual_volume.label':
    'Volumen Anual de Procesamiento Esperado',
  'payment_application.business_details.expected_annual_volume.placeholder': 'XX,XXX,XXX',
  'payment_application.business_details.expected_annual_volume.prefix': 'USD\u00a0$',
  'payment_application.business_details.expected_annual_volume.suffix': '/\u00a0anual',
  'payment_application.business_details.expected_annual_volume.helper':
    'Monto anual del volumen esperado procesado únicamente a través de TouchBistro Payments (no de las ventas totales). Para clientes solo CNP, ingrese únicamente el monto esperado para esta categoría (sin incluir CNP).',

  // Expected Average Transaction
  'payment_application.business_details.expected_average_transaction.label':
    'Monto Promedio Esperado por Transacción',
  'payment_application.business_details.expected_average_transaction.placeholder': 'XXXX',
  'payment_application.business_details.expected_average_transaction.prefix': 'USD\u00a0$',
  'payment_application.business_details.expected_average_transaction.helper':
    'Monto promedio de venta en el año anterior. Para un negocio nuevo, proporcione una estimación de cuál será.',

  // Processing Description
  'payment_application.business_details.processing_description.label':
    '¿Para qué procesa pagos su negocio y cómo se venden los bienes?',
  'payment_application.business_details.processing_description.placeholder':
    'p. ej. Comida y bebidas de brunch en nuestro restaurante',

  // Business Registration section
  'payment_application.business_details.business_registration.section': 'Registro del Negocio',

  // Business Type
  'payment_application.business_details.business_type.label': 'Tipo de Negocio',
  'payment_application.business_details.business_type.placeholder': 'Seleccione una opción',
  'payment_application.business_details.business_type.helper':
    'Seleccione la opción que coincida con lo indicado en sus documentos de registro comercial ante la Secretaría de Estado.',

  // TIN Type
  'payment_application.business_details.tin_type.label': 'Tipo de TIN',
  'payment_application.business_details.tin_type.placeholder': 'Seleccione una opción',

  // EIN
  'payment_application.business_details.ein.label': 'EIN',
  'payment_application.business_details.ein.placeholder': 'EIN de 9 dígitos',
  'payment_application.business_details.ein.helper':
    'Se encuentra en su carta del IRS. Para empresas unipersonales, ingrese el SSN del propietario si no se emitió un EIN.',
  'payment_application.business_details.ein.tooltip':
    'Su Número de Identificación de Empleador (EIN) de 9 dígitos emitido por el IRS.',

  // Date Established
  'payment_application.business_details.date_established.label':
    'Fecha de Establecimiento del Negocio',
  'payment_application.business_details.date_established.placeholder': 'MM/DD/AAAA',

  // Is Public Company
  'payment_application.business_details.is_public_company.label': '¿Es una empresa pública?',
  'payment_application.business_details.is_public_company.placeholder': 'Seleccione una opción',

  // Business Contact section
  'payment_application.business_details.business_contact.section':
    'Información de Contacto del Negocio',

  // Business Phone
  'payment_application.business_details.business_phone.label': 'Número de Teléfono del Negocio',
  'payment_application.business_details.business_phone.helper':
    'Ingrese un número de teléfono de 10 dígitos.',

  // Customer Service Phone
  'payment_application.business_details.customer_service_phone.label':
    'Número de Teléfono de Atención al Cliente',
  'payment_application.business_details.customer_service_phone.helper':
    'Ingrese el número de teléfono que aparecerá en el extracto de la tarjeta del cliente. Si no se proporciona ninguno, se mostrará el Número de Teléfono del Negocio.',

  // Business Email
  'payment_application.business_details.business_email.label': 'Correo Electrónico del Negocio',
  'payment_application.business_details.business_email.placeholder': 'ejemplo@correo.com',

  // Business Website
  'payment_application.business_details.business_website.label': 'Sitio Web del Negocio',
  'payment_application.business_details.business_website.placeholder': 'susitio.com',
  'payment_application.business_details.business_website.helper':
    'No se permiten sitios web de socios ni sitios web genéricos utilizados para varios comerciantes.',
  'payment_application.business_details.business_website.no_website': 'Sin sitio web',

  // Business Address section
  'payment_application.business_details.business_address.section': 'Dirección del Negocio',

  // Address Line 1
  'payment_application.business_details.address_line_1.label': 'Dirección Línea 1',
  'payment_application.business_details.address_line_1.placeholder': 'Ingrese su dirección',
  'payment_application.business_details.address_line_1.helper':
    'Ingrese la dirección donde se desarrolla la actividad del negocio. No se aceptarán apartados postales, espacios de oficina compartidos ni direcciones de servicios de reenvío.',

  // Address Line 2
  'payment_application.business_details.address_line_2.label': 'Dirección Línea 2',
  'payment_application.business_details.address_line_2.placeholder': 'Apartamento, piso, edificio',

  // City
  'payment_application.business_details.city.label': 'Ciudad',
  'payment_application.business_details.city.placeholder': 'Ingrese su ciudad',

  // State
  'payment_application.business_details.state.label': 'Estado',
  'payment_application.business_details.state.placeholder': 'Seleccione una opción',

  // Zip Code
  'payment_application.business_details.zip_code.label': 'Código Postal',
  'payment_application.business_details.zip_code.placeholder': 'XXXXX',

  // Validation
  'payment_application.business_details.validation.required': 'Este campo es obligatorio',
  'payment_application.business_details.validation.email':
    'Ingrese una dirección de correo electrónico válida',
  'payment_application.business_details.validation.url': 'Ingrese una URL de sitio web válida',
  'payment_application.business_details.validation.ein': 'Ingrese un EIN válido de 9 dígitos',
  'payment_application.business_details.validation.zip':
    'Ingrese un código postal válido de 5 dígitos',

  // CTA
  'payment_application.business_details.cta.next_step': 'Siguiente Paso',

  // == Business Owners Page ==
  'payment_application.business_owners.header.title': 'Propietarios del Negocio',
  'payment_application.business_owners.header.body':
    'Cuéntenos sobre las personas que poseen el 25 % o más de su negocio. Debemos recopilar esta información para verificar y procesar su solicitud. También puede incluir propietarios con participaciones menores si esto aporta claridad.',

  'payment_application.business_owners.info.title': 'Información del Propietario {{index}}',
  'payment_application.business_owners.info.body':
    'Ingrese la información del propietario exactamente como aparece en sus documentos emitidos por el gobierno.',
  'payment_application.business_owners.address.title': 'Dirección del Propietario {{index}}',
  'payment_application.business_owners.field.primary_owner.label': 'Propietario principal',
  'payment_application.business_owners.field.first_name.label': 'Nombre',
  'payment_application.business_owners.field.first_name.placeholder':
    'Ingrese el nombre del propietario',
  'payment_application.business_owners.field.middle_name.label': 'Segundo Nombre',
  'payment_application.business_owners.field.middle_name.placeholder':
    'Ingrese el segundo nombre del propietario',
  'payment_application.business_owners.field.last_name.label': 'Apellido',
  'payment_application.business_owners.field.last_name.placeholder':
    'Ingrese el apellido del propietario',
  'payment_application.business_owners.field.ownership_percentage.label': 'Porcentaje de Propiedad',
  'payment_application.business_owners.field.business_phone.label':
    'Número de Teléfono del Negocio',
  'payment_application.business_owners.field.email_address.label': 'Correo Electrónico',
  'payment_application.business_owners.field.email_address.placeholder': 'ejemplo@correo.com',
  'payment_application.business_owners.field.country.label': 'País',
  'payment_application.business_owners.field.date_of_birth.label': 'Fecha de Nacimiento',
  'payment_application.business_owners.field.date_of_birth.placeholder': 'MM/DD/AAAA',
  'payment_application.business_owners.field.social_security_number.label':
    'Número de Seguro Social',
  'payment_application.business_owners.field.social_security_number.placeholder':
    'p. ej. 111 - 11 - 1111',
  'payment_application.business_owners.field.social_security_number.helper':
    '• Si no tiene un SSN, puede ingresar un ITIN. Sin embargo, el negocio debe tener un EIN, la cuenta bancaria debe ser de EE. UU. y TouchBistro se comunicará si se requiere documentación adicional.\n• Si no es residente de EE. UU. y no tiene ITIN, puede enviar su número de pasaporte y TouchBistro se comunicará si se requiere documentación adicional.',
  'payment_application.business_owners.field.business_title.label': 'Cargo en el Negocio',
  'payment_application.business_owners.field.business_title.placeholder':
    'p. ej. CEO, Director, Propietario',
  'payment_application.business_owners.field.business_title.helper': 'Su rol en la empresa.',
  'payment_application.business_owners.field.address_line_1.label': 'Dirección 1',
  'payment_application.business_owners.field.address_line_1.placeholder': 'Ingrese su dirección',
  'payment_application.business_owners.field.address_line_1.helper':
    'Ingrese la dirección física del local donde se desarrolla la actividad del negocio. No se aceptan apartados postales, espacios de oficina compartidos ni direcciones de servicios de reenvío.',
  'payment_application.business_owners.field.address_line_2.label': 'Dirección 2',
  'payment_application.business_owners.field.address_line_2.placeholder':
    'Apartamento, piso, edificio',
  'payment_application.business_owners.field.city.label': 'Ciudad',
  'payment_application.business_owners.field.city.placeholder': 'Ingrese su ciudad',
  'payment_application.business_owners.field.state.label': 'Estado',
  'payment_application.business_owners.field.state.placeholder': 'Seleccione una opción',
  'payment_application.business_owners.field.zip_code.label': 'Código Postal',
  'payment_application.business_owners.field.zip_code.placeholder': 'XXXXX',
  'payment_application.business_owners.cta.next_step': 'Siguiente Paso',
  'payment_application.business_owners.cta.add_owner': 'Agregar Otro Propietario',
  'payment_application.business_owners.cta.save_owner': 'Guardar Propietario',
  'payment_application.business_owners.cta.cancel': 'Cancelar',
  'payment_application.business_owners.cta.edit': 'Editar',
  'payment_application.business_owners.cta.remove': 'Eliminar',
  'payment_application.business_owners.summary.primary_tag': '(Principal)',
  'payment_application.business_owners.summary.ownership': '{{percentage}}% de propiedad',

  // == Banking Details Page ==
  'payment_application.banking_details.header.title': 'Datos Bancarios',
  'payment_application.banking_details.header.body':
    'Agregue la cuenta bancaria en la que desea recibir sus depósitos.',
  'payment_application.banking_details.header.body_extra':
    'Cualquier cambio futuro a su información bancaria requiere validación con un cheque anulado, una carta bancaria o un extracto, y la cuenta debe pertenecer al negocio o al propietario del negocio. De lo contrario, los depósitos podrían retenerse.',
  'payment_application.banking_details.section.bank_information':
    'Ingrese la Información de su Banco',
  'payment_application.banking_details.bank_information_disclaimer':
    'Al proporcionar esta información bancaria, usted declara que esta cuenta bancaria pertenece a este comerciante y está a nombre del titular de la cuenta o del comerciante con la institución financiera.',
  'payment_application.banking_details.illustration.alt':
    'Cheque de EE. UU. de muestra que destaca el número de ruta, el número de cuenta y el número de cheque',
  'payment_application.banking_details.field.account_type.label': 'Tipo de Cuenta',
  'payment_application.banking_details.field.account_type.placeholder': 'Seleccione una opción',
  'payment_application.banking_details.field.routing_number.label': 'Número de Ruta',
  'payment_application.banking_details.field.routing_number.placeholder':
    'Número de ruta de la cuenta bancaria del negocio',
  'payment_application.banking_details.field.routing_number.helper':
    'Número de ruta de la cuenta bancaria del negocio.',
  'payment_application.banking_details.field.account_number.label': 'Número de Cuenta',
  'payment_application.banking_details.field.account_number.placeholder': 'p. ej. 123456789012345',
  'payment_application.banking_details.field.account_number.helper':
    'Número de cuenta de la cuenta bancaria del negocio.',
  'payment_application.banking_details.field.confirm_account_number.label':
    'Confirmar Número de Cuenta',
  'payment_application.banking_details.field.confirm_account_number.placeholder':
    'p. ej. 123456789012345',

  // == Portal Account ==
  'payment_application.portal_account.header.title': 'Configuración de la Cuenta del Portal',
  'payment_application.portal_account.header.body':
    'Crea tu acceso al Portal Payrix para ver reportes de transacciones, gestionar disputas y consultar estados de cuenta mensuales.',
  'payment_application.portal_account.section.create_user_account': 'Crear una Cuenta de Usuario',
  'payment_application.portal_account.section_body':
    'Crea un nombre de usuario y una contraseña para acceder al Portal Payrix. Puedes crear usuarios adicionales más adelante desde el Portal Payrix. Se enviará un enlace de confirmación al correo electrónico proporcionado. La confirmación de la cuenta es necesaria antes de la activación.',
  'payment_application.portal_account.field.username.label': 'Nombre de Usuario',
  'payment_application.portal_account.field.username.placeholder': 'Texto',
  'payment_application.portal_account.field.username.helper':
    '• Debe incluir al menos 1 número y 1 letra',
  'payment_application.portal_account.field.email_address.label': 'Correo Electrónico',
  'payment_application.portal_account.field.email_address.placeholder': 'ejemplo@correo.com',
  'payment_application.portal_account.field.password.label': 'Contraseña',
  'payment_application.portal_account.field.password.placeholder': 'Texto',
  'payment_application.portal_account.field.password.helper_format':
    '• Debe incluir 1 número, 1 letra mayúscula y 1 letra minúscula',
  'payment_application.portal_account.field.password.helper_length':
    '• Debe tener al menos 8 caracteres',
  'payment_application.portal_account.field.confirm_password.label': 'Confirmar Contraseña',
  'payment_application.portal_account.field.confirm_password.placeholder': 'Texto',
  'payment_application.portal_account.validation.username_format':
    'El nombre de usuario debe incluir al menos 1 número y 1 letra',
  'payment_application.portal_account.validation.password_format':
    'La contraseña debe incluir 1 número, 1 letra mayúscula y 1 letra minúscula',
  'payment_application.portal_account.validation.password_length':
    'La contraseña debe tener al menos 8 caracteres',
  'payment_application.portal_account.validation.passwords_match':
    'Las contraseñas deben coincidir. Por favor verifica ambos campos.',

  // == Generic CTAs ==
  'payment_application.cta.back': 'Atrás',
  'payment_application.cta.next': 'Siguiente Paso',

  // == Dropdown enum translations ==

  // MerchantCategoryCode
  'payment_application.enum.merchant_category_code.5811.label': 'Servicios de Catering',
  'payment_application.enum.merchant_category_code.5811.description':
    'Preparación y entrega de alimentos para eventos, fiestas y funciones privadas.',
  'payment_application.enum.merchant_category_code.5812.label': 'Locales de Comida y Restaurantes',
  'payment_application.enum.merchant_category_code.5812.description':
    'Restaurantes de servicio completo donde los clientes ordenan, son atendidos y pagan en la mesa.',
  'payment_application.enum.merchant_category_code.5813.label':
    'Establecimientos de Bebidas (Alcohólicas), Bares, Tabernas, Coctelerías, Clubes Nocturnos y Discotecas',
  'payment_application.enum.merchant_category_code.5813.description':
    'Bares, tabernas, coctelerías, clubes nocturnos y discotecas cuyas ventas principales son bebidas alcohólicas.',
  'payment_application.enum.merchant_category_code.5814.label': 'Restaurantes de Comida Rápida',
  'payment_application.enum.merchant_category_code.5814.description':
    'Restaurantes de servicio rápido donde los clientes ordenan en un mostrador o quiosco y la comida se prepara con rapidez.',

  // MerchantEnvironment
  'payment_application.enum.merchant_environment.INVENUE.label': 'En el Local',
  'payment_application.enum.merchant_environment.ONLINE.label': 'En Línea',
  'payment_application.enum.merchant_environment.INVENUE_AND_ONLINE.label':
    'En el Local y En Línea',
  'payment_application.enum.merchant_environment.MANUALLY_KEYED.label': 'Ingreso Manual',

  // BusinessType
  'payment_application.enum.business_type.SOLE_PROPRIETORSHIP.label': 'Empresa Unipersonal',
  'payment_application.enum.business_type.CORPORATION.label': 'Corporación',
  'payment_application.enum.business_type.LIMITED_LIABILITY_COMPANY.label':
    'Sociedad de Responsabilidad Limitada',
  'payment_application.enum.business_type.PARTNERSHIP.label': 'Sociedad',
  'payment_application.enum.business_type.NON_PROFIT_CORPORATION.label':
    'Corporación Sin Fines de Lucro',

  // TinType
  'payment_application.enum.tin_type.SSN.label': 'SSN',
  'payment_application.enum.tin_type.TIN.label': 'EIN',
  'payment_application.enum.tin_type.OTHER.label': 'Otro',

  // IsPublicCompany
  'payment_application.enum.is_public_company.YES.label': 'Sí',
  'payment_application.enum.is_public_company.NO.label': 'No',

  // AccountType
  'payment_application.enum.account_type.CHEQUING.label': 'Cuenta Corriente',
  'payment_application.enum.account_type.SAVINGS.label': 'Cuenta de Ahorros',
  'payment_application.enum.account_type.BUSINESS_CHEQUING.label': 'Cuenta Corriente Empresarial',
  'payment_application.enum.account_type.BUSINESS_SAVINGS.label': 'Cuenta de Ahorros Empresarial',

  // == Review (Step 5) ==
  'payment_application.review.header.title': 'Revisar y Enviar',
  'payment_application.review.header.body':
    'Tómese un momento para confirmar que todo esté correcto antes de enviar su solicitud.',
  'payment_application.review.section.owners': 'Propietarios',
  'payment_application.review.subsection.user_account': 'Cuenta de Usuario',
  'payment_application.review.subsection.bank_information': 'Información Bancaria',
  'payment_application.review.edit.business_details': 'Editar Detalles del Negocio',
  'payment_application.review.edit.owner': 'Editar Propietario {{index}}',
  'payment_application.review.edit.portal_account': 'Editar Configuración de Cuenta del Portal',
  'payment_application.review.edit.banking_details': 'Editar Datos Bancarios',
  'payment_application.review.consent':
    'He leído y acepto la <bankLink>Página de Divulgación Bancaria</bankLink> y los <termsLink>Términos y Condiciones del Comerciante</termsLink>, y certifico que la información de esta solicitud es correcta según mi leal saber y entender.',
  'payment_application.review.cta.submit': 'Enviar',
}

export default paymentApplication
